import { useEffect, useMemo } from "react";
import { elSemEstrutura } from "src/components/projetos/dimensionados_hibrido/containers/modalEditarEstruturas";
import { EstruturaListagemResponse } from "src/components/projetos/types";
import { InputComboBoxList } from "src/framework/components/forms/inputs/InputComboBoxList";
import { useProjetosHibridoStore } from "src/store/vendas/projetos/hibrido/hibrido.store";
import { FormProjetoHibridoType } from "src/store/vendas/projetos/hibrido/hibrido.types";
import { InputPrefix } from "./InputPrefix";

interface TipoEstruturaInputProps {
  errorState: string[];
  formState: FormProjetoHibridoType;
  onChangeValue: (formState: Partial<FormProjetoHibridoType>) => void;
}

const format = (item: EstruturaListagemResponse) => {
  return {
    ...item,
    estruturas_grupo_id: item.estruturas_grupo_id,
    value: item.id,
    text: item.nome,
  }
}

export const TipoEstruturaInput = ({ errorState, formState, onChangeValue }: TipoEstruturaInputProps) => {
  const projetosHibridoValidationStoreState = useProjetosHibridoStore(store => store.state.validations)
  const projetosHibridoLoadingStoreState = useProjetosHibridoStore(store => store.state.loadings)
  const projetosHibridoStoreActions = useProjetosHibridoStore(store => store.actions)
  const projetosHibridoStoreState = useProjetosHibridoStore(store => store.state)

  const estruturaExibir = useMemo(()=>{
    return formState.fileiras[0]?.tipo_estrutura || null;
  },[formState.fileiras])

  const primeiraFileira = formState.fileiras?.[0];

  useEffect(()=>{
    // Limpa a estrutura selecionada, se for "Sem estrutura" e selecionar módulo Finame
    if (projetosHibridoStoreState.data.modulo_selecionado?.finame && primeiraFileira?.tipo_estrutura?.value === 0) {
      projetosHibridoStoreActions.atualizaOrCriaFileira({ tipo_estrutura: null }, 0)
    }
  },[projetosHibridoStoreState.data.modulo_selecionado, primeiraFileira])

  const options = useMemo(()=>{
    const optionsLocal = [];

    if (!primeiraFileira) return [];

    if (primeiraFileira.posicao_modulo?.value === 'retrato') {
      optionsLocal.push(...formState.estruturas_retrato.map(format));
    }

    if (primeiraFileira.posicao_modulo?.value === 'paisagem') {
      optionsLocal.push(...formState.estruturas_paisagem.map(format));
    }

    if (projetosHibridoStoreState.data.modulo_selecionado?.finame) {
      return optionsLocal;
    }

    return [elSemEstrutura, ...optionsLocal];
  },[formState.fileiras, formState.estruturas_paisagem, projetosHibridoStoreState.data.modulo_selecionado?.finame, formState.estruturas_retrato])

  return (
    <InputComboBoxList
      id={"hibrido-tipo-estrutura-field"}
      key={`hibrido-tipo-estrutura-field`}
      label={"* Tipo de estrutura"}
      prefix={<InputPrefix />}
      textField="text"
      valueField="value"
      error={!projetosHibridoValidationStoreState.estrutura.status || errorState.includes("tipo_estrutura_hibrido")}
      options={options}
      disableClearable
      disabled={!options.length || !projetosHibridoStoreState.data.modulo_selecionado || !primeiraFileira?.posicao_modulo || projetosHibridoLoadingStoreState.listagemEstruturas}
      helperText={projetosHibridoValidationStoreState.estrutura.helper}
      value={estruturaExibir || null}
      autoComplete
      renderOptions={(option: any) => {
          return `${option?.text}`
      }}
      renderOptionsLabel={(option: any) => {
          return `${option?.text}`
      }}
      onChange={(value) => {
        projetosHibridoStoreActions.changeValidationsValue({ estrutura: { helper: '', status: true }})
        projetosHibridoStoreActions.atualizaOrCriaFileira({ tipo_estrutura: value }, 0)
      }}
    />
  )
}